"use server";

import { signup as signupSession } from "@/src/actions/auth-session";
import { ApiError } from "@/src/lib/api/types";

type SignUpResult =
  | { session: boolean }
  | { error: string }
  | { emailExists: true };

export async function signUp(data: {
  email: string;
  password: string;
  fullName: string;
  companyName?: string;
}): Promise<SignUpResult> {
  try {
    await signupSession({
      email: data.email,
      password: data.password,
      fullName: data.fullName,
      companyName: data.companyName,
    });
    return { session: true };
  } catch (e) {
    if (e instanceof ApiError) {
      if (e.status === 409) return { emailExists: true };
      return { error: e.message };
    }
    return {
      error: e instanceof Error ? e.message : "Failed to create account",
    };
  }
}
